<template>
  <div>
    <nav class="header brand-nav navbar navbar-expand-lg">
      <div class="container py-0">
        <a class="navbar-brand" href="#">
          <img src="@/assets/trinitas-head.png" height="60px" class="d-inline-block align-top" alt="">
        </a>
        <div class="collapse navbar-collapse mr-3" id="navbarText">
          <span class="navbar-text d-md-flex ml-md-auto">
            Hola, &nbsp;<a href="">{{ username }}</a>
          </span>
        </div>
        <div class="mr-3">
          <span class="navbar-text d-md-flex ml-md-auto">
           <a href="/logout"> Salir </a>
          </span>
        </div>
      </div>
    </nav>
    <div class="header-menu brand-nav navbar navbar-expand-sm">
      <div class="container py-0">
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#header-menu" aria-controls="header-menu" aria-expanded="false" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse" id="header-menu">
          <ul class="navbar-nav mr-auto mt-2 mt-lg-0">
            <li class="nav-item" v-if="platform == 'acreedores'">
              <router-link class="nav-link" to="/dashboard">
                Dashboard
              </router-link>
            </li>
            <li class="nav-item" v-if="platform == 'ahorros'">
              <router-link class="nav-link" to="/colaborators">
                Colaboradores
              </router-link>
            </li>
            <li class="nav-item" v-if="platform == 'ahorros'">
              <router-link class="nav-link" to="/savings_cuts">
                Cortes de Ahorro
              </router-link>
            </li>
            <li class="nav-item" v-if="platform == 'ahorros'">
              <router-link class="nav-link" to="/movements">
                Movimientos
              </router-link>
            </li>
            <li class="nav-item" v-if="platform == 'acreedores'">
              <router-link class="nav-link" to="/investors">
                Acreedores
              </router-link>
            </li>
            <li class="nav-item" v-if="platform == 'acreedores'">
              <router-link class="nav-link" to="/promoters">
                Impulsores
              </router-link>
            </li>
            <li class="nav-item" v-if="platform == 'acreedores'">
              <router-link class="nav-link" to="/prospects">
                Prospectos
              </router-link>
            </li>
            <li class="nav-item" v-if="platform == 'acreedores'">
              <router-link class="nav-link" to="/contracts">
                Contratos
              </router-link>
            </li>
            <li class="nav-item" v-if="platform == 'acreedores'">
              <router-link class="nav-link" to="/attachments">
                Anexos
              </router-link>
            </li>
            <li class="nav-item" v-if="platform == 'acreedores'">
              <router-link class="nav-link" to="/withdraws">
                Retiros
              </router-link>
            </li>
            <li class="nav-item" v-if="platform == 'acreedores'">
              <router-link class="nav-link" to="/monthly_cuts">
                Cortes
              </router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/users">
                Usuarios
              </router-link>
            </li>
            <li class="nav-item">
              <router-link class="nav-link" to="/configs">
                Config
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      open: false
    }
  },
  computed: {
    username: function () {
      return this.$store.getters.getUsername
    },
    platform: function () {
      return this.$store.getters.getPlatform
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/layouts/Header.vue